import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";

import BusinessIcon from "@material-ui/icons/Business";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import { useHistory } from "react-router-dom";
import SettingOption from "../../providers/SettiingOption";
import CalendarSetting from "../../../images/circuit-board.svg";
import ServiceSetting from "../../../images/dominos.svg";
import UserSetting from "../../../images/floating-cogs.svg";
import useBDocTranslator from "../../hooks/useBDocTranslator";
import DashboardAdmin from "../DashboardAdmin";
import LocationSetting from "../../../images/location-icon.svg";
import SettingsIcon from "../../../images/settings-icon.svg";
import GearSettingIcon from "../../../images/gear-icon-setting.png";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  responsive: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  info: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  content: {
    flex: "1 0 auto",
  },
  Icon: {
    height: 15,
    width: 20,
  },
}));

export default function AdminSetting() {
  const history = useHistory();
  const classes = useStyles();
  const { t, changeDirectLanguage } = useBDocTranslator();

  useEffect(() => {
    changeDirectLanguage();
  }, []);

  return (
    <DashboardAdmin>
      <div className="row">
        {/* Plan Management */}
        <SettingOption
          link="/users/plan/create"
          title={t("Manage Plans")}
          banner={GearSettingIcon}
          optionTitle={t("Plans Management")}
        />

        {/* Affiliations Management */}
        <SettingOption
          link="/users/affiliations/list"
          title={t("Manage Affiliations")}
          banner={GearSettingIcon}
          optionTitle={t("Affiliations Management")}
        />

        {/* Pending Plan Beneficiaries Management */}
        <SettingOption
          link="/users/pending-beneficiaries"
          title={t("Manage Beneficiaries Status")}
          banner={GearSettingIcon}
          optionTitle={t("Pending Beneficiaries")}
        />

        {/* Practice Locations Management */}
        <SettingOption
          link="/users/practice-locations"
          title={t("Manage Practice Locations")}
          banner={GearSettingIcon}
          optionTitle={t("Practice Locations Management")}
        />

        {/* Configuration Management */}
        <SettingOption
          link="/users/settings/configurations"
          title={t("Manage Application Level Configurations")}
          banner={GearSettingIcon}
          optionTitle={t("Configurations Management")}
        />

        {/* Virtual Assistant Usage Report */}
        <SettingOption
          link="/users/settings/assistant-usage-report"
          title={t("View Virtual Assistant Usage Report")}
          banner={GearSettingIcon}
          optionTitle={t("Assistant Usage Report")}
        />

        {/* Driver Medical Certificate Requests Management */}
        <SettingOption
          link="/users/driver-medical-certificate/requests"
          title={t("Manage Driver Medical Certificate Requests")}
          banner={GearSettingIcon}
          optionTitle={t("Dictámenes Médicos")}
        />

        {/* Bulk Import of Places */}
        <SettingOption
          link="/users/settings/places-bulk-import"
          title={t("Bulk Import Places")}
          banner={GearSettingIcon}
          optionTitle={t("Places Bulk Import")}
        />
      </div>
    </DashboardAdmin>
  );
}
